export const WARNING_DISPLAY_VARIABLE_MAX_COUNT = 1000
export const EXPORT_API_URL = '/export'
